export const CSS = {
  container: "container",
  content: "content",
  contentHeader: "content__header",
  contentBody: "content__body",
  contentFloat: "content--float",
  contentOverlay: "content--overlay",
  separator: "separator",
};

export const SLOTS = {
  actionBar: "action-bar",
  header: "header",
};
